import { GetAutoCompleteData } from "./addMonacoCompletionProvider";
import { ActionDescriptior, MonacoType, MonacoEditor as MonacoEditorType } from "./monaco.types";
import dynamic from "next/dynamic";
import React from "react";
import Skeleton from "react-loading-skeleton";

const MonacoEditor = dynamic(() => import("./MonacoEditor"), { ssr: false, loading: () => <Skeleton count={10} /> });

interface Props {
  language?: string;
  defaultValue: string;
  formattedValue?: string;
  onChange: (value: string) => void;
  getAutoCompleteData?: GetAutoCompleteData;
  actions?: (monaco: MonacoType) => ActionDescriptior[];
  readOnly?: boolean;
  initialHeight?: number;
  didMountCallback?: (editor: MonacoEditorType) => void;
}

/**
 * Because the Monaco Editor has to be imported dynamically, this wrapper serves as a midway point to
 * import Monaco safely and also handle functionalities that should be consistent wherever the editor is used.
 */
export default function MonacoEditorWrapper({
  language,
  defaultValue,
  formattedValue,
  onChange,
  getAutoCompleteData,
  actions,
  initialHeight,
  readOnly = false,
  didMountCallback,
}: Props): React.ReactElement {
  return (
    <MonacoEditor
      initialHeight={initialHeight}
      language={language}
      defaultValue={defaultValue}
      onChange={onChange}
      formattedValue={formattedValue}
      getAutoCompleteData={getAutoCompleteData}
      actions={actions}
      readOnly={readOnly}
      didMountCallback={didMountCallback}
    />
  );
}
